import {AfterViewInit, Component, Input, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {TableField} from "../../../../../common/table/table-view/table-view.component";
import {
  IE3ConsignmentHouseLevel,
  IE3ConsignmentProcess,
  IE3GoodsItemSummary
} from "@portbase/bezoekschip-service-typescriptmodels";
import {openEditModal} from "../../../../../common/utils";
import {
  GoodsConsignmentDetailsComponent,
  GoodsConsignmentDetailsComponentData
} from "../../goods-consignment-details/goods-consignment-details.component";
import {GoodsItemSummaryWithHouseConsignments} from "../../../consignment.utils";
import {
  EquipmentConsignmentDetailsComponent,
  EquipmentConsignmentDetailsComponentData
} from "../../equipment-consignment-details/equipment-consignment-details.component";

@Component({
    selector: 'app-consignment-goods-table',
    templateUrl: './consignment-goods-table.component.html',
    styleUrls: ['./consignment-goods-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsignmentGoodsTableComponent implements AfterViewInit {
  @Input() consignmentProcess: IE3ConsignmentProcess;
  @Input() houseConsignment: IE3ConsignmentHouseLevel;
  @Input() equipmentNumber: string;
  @Input() data: GoodsItemSummaryWithHouseConsignments[];
  @Input() editable: boolean = true;
  @Input() errorGoodsItemNumbers: Set<number> = new Set();
  term: string;
  fieldsDefinition: TableField[] = [];

  @ViewChild("placementsRef") placementsRef: TemplateRef<any>;
  @ViewChild("goodsRef") goodsRef: TemplateRef<any>;
  @ViewChild("actionColumnRef") actionColumnRef: TemplateRef<any>;
  @ViewChild("houseConsignmentRef") houseConsignmentRef: TemplateRef<any>;

  ngAfterViewInit(): void {
    this.fieldsDefinition = [
      {
        type: "string",
        header: "Goods",
        name: "goodsItem",
        template: this.goodsRef
      }, {
        type: "string",
        name: "goodsItem.placements",
        header: "Equipment",
        template: this.placementsRef,
        hidden: !!this.equipmentNumber
      }, {
        type: "string",
        name: "houseConsignments",
        header: "House B/Ls",
        hidden: !!this.houseConsignmentNumber,
        template: this.houseConsignmentRef
      }, {
        type: "action",
        name: "actionColumn",
        template: this.actionColumnRef,
        cellClass: "p-1 auto-width"
      }
    ]
  }

  get houseConsignmentNumber() {
    return this.houseConsignment?.consignmentNumber;
  }

  trackByGoodsItemNumber = (goodsItem: GoodsItemSummaryWithHouseConsignments) => goodsItem.goodsItem.goodsItemNumber;

  goodsRowClassFn = (record: GoodsItemSummaryWithHouseConsignments) =>
    this.errorGoodsItemNumbers?.has(record?.goodsItem?.goodsItemNumber) ? 'table-danger' : '';

  edit = (record: GoodsItemSummaryWithHouseConsignments) =>
    openEditModal(GoodsConsignmentDetailsComponent, <GoodsConsignmentDetailsComponentData>{
      consignmentProcessId: this.consignmentProcess.consignmentProcessId,
      goodsItemNumber: record?.goodsItem.goodsItemNumber,
      houseConsignmentNumber: this.houseConsignmentNumber,
      cachedHouseConsignment: this.houseConsignment,
      equipmentNumber: this.equipmentNumber,
      cachedConsignmentProcess: this.consignmentProcess
    }, {
      warnOnClose: true,
      currentToStack: true
    });

  editEquipment = (equipmentNumber: string) => openEditModal(EquipmentConsignmentDetailsComponent, <EquipmentConsignmentDetailsComponentData>{
    consignmentProcessId: this.consignmentProcess.consignmentProcessId,
    equipmentNumber: equipmentNumber,
    cachedConsignmentProcess: this.consignmentProcess,
    houseConsignmentNumber: this.houseConsignmentNumber
  }, {
    warnOnClose: true,
    currentToStack: true
  });

  editGoodsItem = (goodsItem: IE3GoodsItemSummary) => openEditModal(GoodsConsignmentDetailsComponent, <GoodsConsignmentDetailsComponentData> {
    consignmentProcessId: this.consignmentProcess.consignmentProcessId,
    goodsItemNumber: goodsItem.goodsItemNumber,
    houseConsignmentNumber: this.houseConsignmentNumber,
    cachedConsignmentProcess: this.consignmentProcess,
    equipmentNumber: this.equipmentNumber,
    cachedHouseConsignment: this.houseConsignment
  }, {
    warnOnClose: true,
    currentToStack: true
  });
}
